<h5>{{ tableLabel }}</h5>
<app-datatable
  [dataSourceUrl]="dtDataSourceUrl"
  [settings]="dtSettings"
  (onInit)="onDtInit($event)"
  (onAction)="onDtAction($event)"
>
  <th class="column-hide" data-data="id">Azonosító</th>
  <th data-data="order">Sorrend</th>
  <th data-data="subjectName">Vizsgatárgy</th>
  <th data-data="examStartedAtUtc" class="datetime">Kezdés időpont</th>
  <th data-data="result">Eredmény</th>
  <th data-data="score" class="score">Pontszám</th>
  <th data-data="measure" class="percentagePrecision">Százalék</th>
  <th data-data="modifiedDateUtc" class="datetime">Beírás dátuma</th>
  <th data-data="lastResultNotificationSendUtc" class="datetime">Utolsó értesítés dátuma</th>
  <th class="column-actions">Műveletek</th>
</app-datatable>

<a id="downloadAnchorElem" style="display:none"></a>
